// eslint-disable-next-line max-len
import feathersClient, { makeServicePlugin, BaseModel, makeServiceStore } from '../../feathers-client';

const servicePath = 'company';

const Model = class Company extends BaseModel {
  static modelName = 'Company';

  static instanceDefaults() {
    return {
    };
  }
};

export default {
  plugin: makeServicePlugin({
    servicePath,
    service: feathersClient.service(servicePath),
    Model,
  }),

  store: makeServiceStore({ servicePath, Model }),
};
